import { REDUX_LOCAL_KEY } from '../../constants/local-key'
import { getValueReduxUtil } from '../get-value'

function isDownloadedReduxUtil (instance) {
  return !!getValueReduxUtil(instance, REDUX_LOCAL_KEY.IS_DOWNLOADED)
}

export { isDownloadedReduxUtil }
